import React, { useEffect } from "react";
import Box from "@mui/material/Box";
// common components imports
import Breadcrumb from "../../common/header/Breadcrumb";
import Header from "../../common/header/Header";
import AppointmentConfirmationTemplate from '../../components/NotificationSettings/AppointmentConfirmationTemplate'

const AppointmentConfirmation = () => {
   useEffect(() => {
            window.scrollTo(0, 0);
        }, []);
  return (
    <>
      <Box sx={{ flexGrow: 1 }} className="page-background">
        <Header />
        <Breadcrumb />
        <AppointmentConfirmationTemplate/>
      </Box>
    </>
  );
};

export default AppointmentConfirmation;
